var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5ZM8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM5.17157 5.17157C5.36684 4.97631 5.68342 4.97631 5.87868 5.17157L8 7.29289L10.1213 5.17157C10.3166 4.97631 10.6332 4.97631 10.8284 5.17157C11.0237 5.36684 11.0237 5.68342 10.8284 5.87868L8.70711 8L10.8284 10.1213C11.0237 10.3166 11.0237 10.6332 10.8284 10.8284C10.6332 11.0237 10.3166 11.0237 10.1213 10.8284L8 8.70711L5.87868 10.8284C5.68342 11.0237 5.36683 11.0237 5.17157 10.8284C4.97631 10.6332 4.97631 10.3166 5.17157 10.1213L7.29289 8L5.17157 5.87868C4.97631 5.68342 4.97631 5.36683 5.17157 5.17157Z",
    fill: "#E71111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d59212993ffc36b8e70e3c01ebeb5fe3.svg";
export { ForwardRef as ReactComponent };